import { render } from "./form12.vue?vue&type=template&id=9ec3aa44&scoped=true"
import script from "./form12.vue?vue&type=script&lang=js"
export * from "./form12.vue?vue&type=script&lang=js"

import "./form12.vue?vue&type=style&index=0&id=9ec3aa44&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec3aa44"]])

export default __exports__